const textStyle = {
    fontSize: 14,
    fontFamily: 'Helvetica, sans-serif',
    color: '#333333',
};

const yAxis = {
    axisLine: {
        show: true,
        lineStyle: {
            color: '#ECEFF1',
            width: 2,
        },
    },
    axisTick: {
        length: 2,
        lineStyle: {
            width: 2,
        },
    },
    axisLabel: textStyle,
    splitLine: {
        show: true,
        lineStyle: {
            color: '#ECEFF1',
            opacity: 0.8,
        },
    },
    nameLocation: 'middle',
    nameTextStyle: {
        textStyle,
        rich: {},
    },
};

/**
 * ECharts'(https://github.com/apache/incubator-echarts) theme object
 * It used ECharts internal format
 * Docs - https://ecomfe.github.io/echarts-doc/public/en/option.html
 * Theme builder - http://echarts.baidu.com/theme-builder/
 */
export default {
    // Semantic theme configuration for charts common components
    // Please put here only configuration options with semantic meaning
    map: {
        locationDefaultColor: '#d6d6d6',
        locationSelectedColor: '#50C3F7',
        locationLabelColor: '#333333',
        locationBorderColor: 'white',
        locationInRangeColorSpectrum: [
            '#199949',
            '#20C05C',
            '#4CCC7C',
            '#82DBA3',
            '#FBDD39',
            '#F7B600',
            '#F18602',
            '#E86D0C',
        ],
        locationOutOfRangeColor: '#ECEFF1',
        sliderAxisColor: '#ECEFF1',
        sliderPointColor: '#C1C8CB',
        sliderPlayButtonColor: '#C1C8CB',
        sliderPlayButtonBorderColor: '#C1C8CB',
        sliderPlayButtonHoverColor: '#96C984',
        sliderPlayButtonBorderHoverColor: '#96C984',
    },
    bar: {
        seriesColorSpectrum: [
            '#9575CD',
            '#82DBA3',
            '#4CCC7C',
            '#20C05C',
            '#199949',
            '#FBDD39',
            '#F7B600',
            '#F18602',
            '#E86D0C',
            '#8D6E63',
        ],
        series: {
            type: 'bar',
            barCategoryGap: 10,
        },
    },
    pie: {
        seriesColorSpectrum: [
            '#9575CD',
            '#82DBA3',
            '#4CCC7C',
            '#20C05C',
            '#199949',
            '#FBDD39',
            '#F7B600',
            '#F18602',
            '#E86D0C',
            '#8D6E63',
        ],
    },

    line: {
        grid: {
            top: 90,
            left: 90,
        },
        colors: [
            {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                    {
                        offset: 0,
                        color: '#86CA46',
                    },
                    {
                        offset: 1,
                        color: '#0DA384',
                    },
                ],
            },
            {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                    {
                        offset: 0,
                        color: '#FAB93A',
                    },
                    {
                        offset: 1,
                        color: '#F06054',
                    },
                ],
            },
        ],
    },

    // Put below any arbitrary configuration copy-pasted from echarts API
    loading: {
        text: 'Loading...',
        color: '#20C05C',
        textColor: '#000',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0,
    },
    textStyle,
    title: {
        top: 0,
        left: 'center',
        backgroundColor: 'rgba(255, 255, 255, .8)',
        textStyle: {
            fontSize: 20,
            fontFamily: '"Aleo", "Times New Roman", Times, serif',
            fontWeight: 'bold',
        },
        subtextStyle: {
            fontSize: 14,
            fontFamily: 'Helvetica, sans-serif',
            color: '#333333',
        },
    },
    noData: {
        top: '45%',
        left: 'center',
        textStyle: {
            ...textStyle,
            fontSize: 26,
        },
    },
    toolbox: {
        feature: {
            saveAsImage: {
                excludeComponents: ['toolbox', 'graphic'],
                pixelRatio: 2,
            },
        },
    },
    legend: {
        z: 10,
        top: 60,
        right: 30,
        orient: 'horizontal',
    },
    tooltip: {
        backgroundColor: 'white',
        extraCssText:
            'box-shadow: 0 10px 10px 0 rgba(0,0,0,0.05), 0 0 10px 0 rgba(0,0,0,0.10), 0 20px 20px 0 rgba(0,0,0,0.08); border-radius: 4px;',
        padding: [16, 20],
        textStyle,
    },
    xAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                width: 2,
            },
        },
        axisLabel: textStyle,
        axisTick: {
            length: 2,
            lineStyle: {
                width: 2,
            },
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                opacity: 0.8,
            },
        },
        nameLocation: 'center',
        nameTextStyle: textStyle,
        nameGap: 45,
    },
    yAxis: [
        {
            ...yAxis,
            id: 0,
        },
        {
            ...yAxis,
            id: 1,
            position: 'right',
        },
    ],
    dataZoom: {
        type: 'slider',
        textStyle: {
            fontSize: 12,
        },
        backgroundColor: '#F5F7F8',
        fillerColor: 'rgba(194,201,204, 0.25)',
        borderColor: 'transparent',
        dataBackground: {
            lineStyle: {
                color: '#ACB8BE',
            },
            areaStyle: {
                color: '#DDE3E6',
            },
        },
        handleStyle: {
            color: '#C2C9CC',
        },
    },
    markLine: {
        symbol: '',
        lineStyle: {
            color: '#20A050',
            width: 2,
        },
        label: {
            show: false,
        },
        animation: false,
    },
};
